/* ==========================================================================
   【ルミエール専用】ショッパブルギャラリー（Lookfy Gallery 置き換え／自作）
   - バニラJSのみ（jQuery・外部ライブラリ不使用）
   - IntersectionObserver でセクションが近づいてから初期化
   - PC：ホバーで商品カード表示（CSSのみ）／モバイル：タップでトグル（このJS）
   - 画像クリックで拡大表示（ライトボックス）。大きい画像は開いた時に初めて読み込む
   ========================================================================== */
(function () {
  'use strict';

  var SELECTOR = '[data-shoppable-gallery]';
  var documentBound = false;

  /* ---------- ホバー中の1枚以外を暗くする ---------- */

  function refreshDim() {
    var wraps = document.querySelectorAll('.sg-grid-wrap');
    for (var i = 0; i < wraps.length; i++) {
      var active = wraps[i].querySelector('.sg-item.is-hovered, .sg-item.is-active');
      if (active) {
        wraps[i].classList.add('is-dimmed');
      } else {
        wraps[i].classList.remove('is-dimmed');
      }
    }
  }

  function setHovered(wrap, item) {
    var prev = wrap.querySelectorAll('.sg-item.is-hovered');
    for (var i = 0; i < prev.length; i++) {
      if (prev[i] !== item) prev[i].classList.remove('is-hovered');
    }
    if (item) item.classList.add('is-hovered');
    refreshDim();
  }

  /* ---------- ホットスポットの商品カード ---------- */

  function closeAll(scope) {
    var opened = (scope || document).querySelectorAll('.sg-spot.is-open');
    for (var i = 0; i < opened.length; i++) {
      opened[i].classList.remove('is-open');
      var btn = opened[i].querySelector('.sg-dot');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      var item = opened[i].closest('.sg-item');
      if (item) item.classList.remove('is-active');
    }
    refreshDim();
  }

  function onDotClick(event) {
    var dot = event.target.closest('.sg-dot');
    if (!dot) return false;

    event.preventDefault();

    var spot = dot.closest('.sg-spot');
    if (!spot) return true;

    var wasOpen = spot.classList.contains('is-open');
    closeAll(document);

    if (!wasOpen) {
      spot.classList.add('is-open');
      dot.setAttribute('aria-expanded', 'true');
      var item = spot.closest('.sg-item');
      if (item) item.classList.add('is-active');
    }
    refreshDim();
    return true;
  }

  /* ---------- 拡大表示（ライトボックス） ---------- */

  function Lightbox(section) {
    this.section = section;
    this.root = section.querySelector('[data-sg-lightbox]');
    this.items = section.querySelectorAll('.sg-item');
    if (!this.root || !this.items.length) return;

    this.img = this.root.querySelector('[data-sg-zoom-img]');
    this.frame = this.root.querySelector('[data-sg-frame]');
    this.list = this.root.querySelector('[data-sg-list]');
    this.caption = this.root.querySelector('[data-sg-caption]');
    this.indexEl = this.root.querySelector('[data-sg-index]');
    this.totalEl = this.root.querySelector('[data-sg-total]');
    this.closeBtn = this.root.querySelector('.sg-lightbox__close');
    this.index = 0;
    this.lastFocus = null;

    if (this.totalEl) this.totalEl.textContent = String(this.items.length);

    var self = this;

    this.root.addEventListener('click', function (event) {
      // 拡大画像の上に複製した点のクリック
      if (onDotClick(event)) return;

      if (event.target.closest('[data-sg-close]')) {
        self.close();
      } else if (event.target.closest('[data-sg-prev]')) {
        self.show(self.index - 1);
      } else if (event.target.closest('[data-sg-next]')) {
        self.show(self.index + 1);
      }
    });

    // 前後送りは画像が1枚のときは出さない
    if (this.items.length < 2) {
      var navs = this.root.querySelectorAll('.sg-lightbox__nav');
      for (var i = 0; i < navs.length; i++) navs[i].style.display = 'none';
    }
  }

  Lightbox.prototype.show = function (index) {
    var total = this.items.length;
    this.index = ((index % total) + total) % total;

    var item = this.items[this.index];

    if (this.img) {
      var w = item.getAttribute('data-zoom-width');
      var h = item.getAttribute('data-zoom-height');
      if (w) this.img.setAttribute('width', w);
      if (h) this.img.setAttribute('height', h);
      this.img.src = item.getAttribute('data-zoom-src') || '';
      this.img.srcset = item.getAttribute('data-zoom-srcset') || '';
      this.img.alt = item.getAttribute('data-zoom-alt') || '';
    }

    if (this.caption) this.caption.textContent = item.getAttribute('data-zoom-caption') || '';
    if (this.indexEl) this.indexEl.textContent = String(this.index + 1);

    // 拡大画像の上にもホットスポットを載せる（グリッド側の点をそのまま複製）
    if (this.frame) {
      var old = this.frame.querySelectorAll('.sg-spot');
      for (var s = 0; s < old.length; s++) old[s].parentNode.removeChild(old[s]);

      var spots = item.querySelectorAll('.sg-spot');
      for (var j = 0; j < spots.length; j++) {
        var clone = spots[j].cloneNode(true);
        clone.classList.remove('is-open');
        var cloneDot = clone.querySelector('.sg-dot');
        if (cloneDot) cloneDot.setAttribute('aria-expanded', 'false');
        this.frame.appendChild(clone);
      }
    }

    if (this.list) {
      this.list.innerHTML = '';
      var cards = item.querySelectorAll('.sg-card');
      for (var i = 0; i < cards.length; i++) {
        this.list.appendChild(cards[i].cloneNode(true));
      }
    }

    this.layout();
    // 前の写真でスクロールしていても、切り替えたら先頭から見せる
    this.root.scrollTop = 0;
  };

  /*
    拡大画像の枠を、その写真の縦横比ぴったりの大きさにそろえる。
    CSSのmax-width／max-heightだけだと、高さ側で縮んだぶんが枠の幅に伝わらず、
    画像の左右にすき間が残ってしまうため、ここで実寸を決めてしまう。
  */
  Lightbox.prototype.layout = function () {
    if (!this.frame || !this.img) return;

    var w = parseFloat(this.img.getAttribute('width'));
    var h = parseFloat(this.img.getAttribute('height'));
    var wide = window.matchMedia('(min-width: 750px)').matches;

    // スマホは横幅いっぱいに出すので、CSSの指定だけで足りる
    if (!w || !h || !wide) {
      this.frame.classList.remove('is-sized');
      this.frame.style.width = '';
      return;
    }

    var cs = window.getComputedStyle(this.root);
    var gapY = parseFloat(cs.getPropertyValue('--sg-lb-gap-y')) || 20;
    var gapX = parseFloat(cs.getPropertyValue('--sg-lb-gap-x')) || 60;
    var panel = parseFloat(cs.getPropertyValue('--sg-lb-panel')) || 300;

    var availH = document.documentElement.clientHeight - gapY * 2;
    var availW = document.documentElement.clientWidth - gapX * 2 - panel;

    // 用意している拡大画像の最大サイズ。これ以上引き伸ばしても粗くなるだけ
    if (availW > 1600) availW = 1600;

    if (availH < 200 || availW < 200) {
      this.frame.classList.remove('is-sized');
      this.frame.style.width = '';
      return;
    }

    this.frame.style.width = Math.floor(Math.min(availW, availH * (w / h))) + 'px';
    this.frame.classList.add('is-sized');
  };

  Lightbox.prototype.open = function (index) {
    this.lastFocus = document.activeElement;
    closeAll(document);
    // 開いている間は一覧側の暗転を解除しておく
    var hovered = this.section.querySelectorAll('.sg-item.is-hovered');
    for (var i = 0; i < hovered.length; i++) hovered[i].classList.remove('is-hovered');
    refreshDim();
    this.show(index);
    this.root.hidden = false;
    document.documentElement.classList.add('sg-lightbox-open');
    // 表示した後にもう一度。背面のスクロールバーが消えたぶん幅が変わるため
    this.layout();
    this.root.scrollTop = 0;
    if (this.closeBtn) this.closeBtn.focus();
  };

  Lightbox.prototype.close = function () {
    this.root.hidden = true;
    document.documentElement.classList.remove('sg-lightbox-open');
    // 閉じたら大きい画像を保持しない
    if (this.img) {
      this.img.removeAttribute('srcset');
      this.img.removeAttribute('src');
    }
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  Lightbox.prototype.isOpen = function () {
    return !this.root.hidden;
  };

  /* ---------- 初期化 ---------- */

  function bindDocument() {
    if (documentBound) return;
    documentBound = true;

    // ギャラリー外のクリックで商品カードを閉じる
    document.addEventListener('click', function (event) {
      if (event.target.closest('.sg-spot')) return;
      closeAll(document);
    });

    document.addEventListener('keydown', function (event) {
      var key = event.key;
      var sections = document.querySelectorAll(SELECTOR);
      var openBox = null;

      for (var i = 0; i < sections.length; i++) {
        var box = sections[i].sgLightbox;
        if (box && box.isOpen()) openBox = box;
      }

      if (openBox) {
        if (key === 'Escape' || key === 'Esc') {
          openBox.close();
        } else if (key === 'ArrowLeft') {
          openBox.show(openBox.index - 1);
        } else if (key === 'ArrowRight') {
          openBox.show(openBox.index + 1);
        }
        return;
      }

      if (key === 'Escape' || key === 'Esc') closeAll(document);
    });

    // 画面の大きさが変わったら、拡大画像の大きさを計算し直す
    window.addEventListener('resize', function () {
      var sections = document.querySelectorAll(SELECTOR);
      for (var i = 0; i < sections.length; i++) {
        var box = sections[i].sgLightbox;
        if (box && box.isOpen()) box.layout();
      }
    });
  }

  function init(section) {
    if (!section || section.dataset.sgReady === '1') return;
    section.dataset.sgReady = '1';

    var lightbox = new Lightbox(section);
    section.sgLightbox = lightbox.root ? lightbox : null;

    /*
      拡大表示は body 直下へ移す。
      position:fixed は祖先に transform 等があると画面全体を覆えなくなるため、
      暗幕を確実に効かせるにはテーマ側の入れ子から出しておくのが安全。
    */
    if (lightbox.root && lightbox.root.parentNode !== document.body) {
      var sid = lightbox.root.getAttribute('data-section-id');
      if (sid) {
        var stale = document.querySelectorAll('body > .sg-lightbox[data-section-id="' + sid + '"]');
        for (var s = 0; s < stale.length; s++) {
          if (stale[s] !== lightbox.root) stale[s].parentNode.removeChild(stale[s]);
        }
      }
      document.body.appendChild(lightbox.root);
    }

    // マウスが乗っている1枚を記録して、それ以外を暗くする
    var wrap = section.querySelector('.sg-grid-wrap');
    if (wrap) {
      wrap.addEventListener('mouseover', function (event) {
        setHovered(wrap, event.target.closest('.sg-item'));
      });
      wrap.addEventListener('mouseleave', function () {
        setHovered(wrap, null);
      });
    }

    section.addEventListener('click', function (event) {
      if (onDotClick(event)) return;

      var zoom = event.target.closest('.sg-zoom');
      if (zoom && section.sgLightbox) {
        event.preventDefault();
        var item = zoom.closest('.sg-item');
        var items = section.querySelectorAll('.sg-item');
        for (var i = 0; i < items.length; i++) {
          if (items[i] === item) {
            section.sgLightbox.open(i);
            break;
          }
        }
      }
    });

    bindDocument();
  }

  function observe(section) {
    if (!section || section.dataset.sgObserved === '1') return;
    section.dataset.sgObserved = '1';

    if (!('IntersectionObserver' in window)) {
      init(section);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          init(entries[i].target);
          observer.unobserve(entries[i].target);
        }
      },
      { rootMargin: '200px 0px' }
    );

    observer.observe(section);
  }

  function observeAll(root) {
    var sections = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < sections.length; i++) observe(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeAll(document);
    });
  } else {
    observeAll(document);
  }

  // テーマエディタでの再読み込みに追従
  document.addEventListener('shopify:section:load', function (event) {
    observeAll(event.target);
  });
})();
